const bulkDiscountsSettings = {
    selectors: {
        ctaButtonContainerSelector: '.bulk-discounts-dropdown__cta-button-container',
        containerSelector: '.bulk-discounts-dropdown',
        dataSelector: '#bulk_discounts',
        tableHeaderSelector: '.bulk-discounts-dropdown__table-header',
        tableRowSelector: '.bulk-discounts-dropdown__table-row',
        tableSelector: '.bulk-discounts-dropdown__table',
        ctaFromSelector: ".bulk-discounts-dropdown__cta-from",
        quantityInputSelector: '#atc-cta .quantity-box input[name="quantity"]',
        quantityBoxSelector: '.quantity-box',
        addonProductsInputSelector: '#addon-products-for-atc',
        priceContainerSelector: '.bulk-discounts-dropdown__price-container',
        priceMessageSelector: '.bulk-discounts-dropdown__price-message',
        atcSelector: '#atc-cta',
        atcContainerSelector: '.atc-bulk-discount-container',
        regularATCContainer: '.main-product__atc-container',
        bulkDiscountATCContainer: '.bulk-discounts-dropdown__atc-container',
        priceElementSelector: '.bulk-discounts-dropdown__price-container .bulk-discounts-dropdown__price',
        savingsElementSelector: '.bulk-discounts-dropdown__price-container .bulk-discounts-dropdown__price-savings',
        highlightCellSelector: '.highlight-cell',
        tableHeaderCellSelector: '.bulk-discounts-dropdown__table-header-cell',
        tableContentCellSelector: '.bulk-discounts-dropdown__table-content-cell'
    },
    htmlElements: {
        tableHeaderCell: `<th class="bulk-discounts-dropdown__table-header-cell">#content#</th>`,
        tableContentCell: `<td class="bulk-discounts-dropdown__table-content-cell">#content#</td>`
    },
    strings: {
        quantity: "Quantity"
    }
}

const findAncestor = function(el, sel) {
    while ((el = el.parentElement) && !((el.matches || el.matchesSelector).call(el,sel)));
    return el;
}

const repositionATC = function(type){
    let bulkDiscountATCContainer = document.querySelector(`${bulkDiscountsSettings.selectors.bulkDiscountATCContainer}`);
    let regularATCContainer = document.querySelector(`${bulkDiscountsSettings.selectors.regularATCContainer}`);
    let atc = document.querySelector(`${bulkDiscountsSettings.selectors.atcSelector}`);
    let fragment = document.createDocumentFragment();
    fragment.appendChild(atc);
    if(type == "open"){
        bulkDiscountATCContainer.appendChild(fragment)
    } else {
        regularATCContainer.appendChild(fragment)
    }
}

const scrollToATC = function(){
    let atc = document.querySelector(`${bulkDiscountsSettings.selectors.atcSelector}`);
    if(atc){
        let atcPosition = atc.getBoundingClientRect().top + window.pageYOffset;
        let viewportHeight = window.innerHeight;
        let targetPosition = atcPosition - viewportHeight + 200;
        window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
        });
    }
}

const toggleDropdown = function(e, type, bulkDiscountsData, productHandle, headerRanges){
    let container = type == 'onQuantityChange' ? document.querySelector(bulkDiscountsSettings.selectors.containerSelector) : findAncestor(e.target, bulkDiscountsSettings.selectors.containerSelector);
    // let atcContainer = document.querySelector(`${bulkDiscountsSettings.selectors.atcContainerSelector}`);

    container.classList.remove(`${bulkDiscountsSettings.selectors.containerSelector.replace(".", "")}--closed`);
    container.classList.remove(`${bulkDiscountsSettings.selectors.containerSelector.replace(".", "")}--open`);
    // atcContainer.classList.remove(`${bulkDiscountsSettings.selectors.atcContainerSelector.replace(".", "")}--open`);
    container.classList.add(`${bulkDiscountsSettings.selectors.containerSelector.replace(".", "")}--changing`);

    if(container.getAttribute('data-status') == 'closed'){
        container.classList.add(`${bulkDiscountsSettings.selectors.containerSelector.replace(".", "")}--open`);
        container.setAttribute('data-status', 'open');
        repositionATC('open');
        
        // Populate table content when dropdown opens
        if(bulkDiscountsData && productHandle && headerRanges) {
            tableContent(bulkDiscountsData, productHandle, headerRanges);
        }
        
        // Recalculate height after content is populated
        let innerContainerHeight =  parseFloat(window.Branch.functions.getStyle(container.querySelector('.bulk-discounts-dropdown--inner-container'), 'height').replace('px', ''));
        container.style.height = `${innerContainerHeight}px`
        
        // atcContainer.classList.add(`${bulkDiscountsSettings.selectors.atcContainerSelector.replace(".", "")}--open`);
    } else {
        container.classList.add(`${bulkDiscountsSettings.selectors.containerSelector.replace(".", "")}--closed`);
        container.setAttribute('data-status', 'closed');
        repositionATC('close');
        container.style.height = '50px'
    }

    setTimeout(() => {
        container.classList.remove(`${bulkDiscountsSettings.selectors.containerSelector.replace(".", "")}--changing`);
    }, 200);
}

const tableHeader = function(currentProductData, headerRanges){
    let tableHeader = document.querySelector(`${bulkDiscountsSettings.selectors.tableHeaderSelector}`);
    let headerCellsHtml = `${bulkDiscountsSettings.htmlElements.tableHeaderCell.replace('#content#', bulkDiscountsSettings.strings.quantity)}`;

    currentProductData.bulk_discount_table.forEach((discountTier, index)=> {
        let headerString = index === currentProductData.bulk_discount_table.length - 1 ? `${discountTier.min}+` : `${discountTier.min}-${discountTier.max}`;
        let max = index === currentProductData.bulk_discount_table.length - 1 ? 999999999999 : discountTier.max;
        
        headerCellsHtml = headerCellsHtml + `${bulkDiscountsSettings.htmlElements.tableHeaderCell.replace('#content#', headerString)}`;
        
        headerRanges.push({'min': discountTier.min, 'max': max});
    });
    
    tableHeader.innerHTML = headerCellsHtml;
}

const returnProductsToDisplay = function(bulkDiscountsData, productHandle, variantId){
    let productsToDisplay = [{"price": bulkDiscountsData[`${productHandle}`][`variant_prices`][`${variantId}`], "product_type": bulkDiscountsData[`${productHandle}`][`product_type`], "discounts": bulkDiscountsData[`${productHandle}`][`bulk_discount_table`], "handle": productHandle, "variantID": variantId}];
    
    if (document.querySelector('#addon-products-for-atc') && document.querySelector('#addon-products-for-atc').getAttribute('value')){
        let addOnProductsData = JSON.parse(document.querySelector('#addon-products-for-atc').getAttribute('value'));

        if(addOnProductsData.length > 0) {
            addOnProductsData.forEach((addOnProductData) => {
                if(bulkDiscountsData[`${addOnProductData.productHandle}`]){
                    productsToDisplay.push({"price": bulkDiscountsData[`${addOnProductData.productHandle}`][`variant_prices`][`${addOnProductData.variantId}`], "product_type": bulkDiscountsData[`${addOnProductData.productHandle}`][`product_type`], "discounts": bulkDiscountsData[`${addOnProductData.productHandle}`][`bulk_discount_table`], "handle": addOnProductData.productHandle, "variantID": addOnProductData.variantId})
                }
            })
        }
    };
    return productsToDisplay
}

const calculateDiscounts = function(productsToDisplay, headerRanges){
    productsToDisplay.forEach((productToDisplay) => {
        let discounts = [];
        headerRanges.forEach((range) => {
            let discountAmount = 0;
            let discountType = 'percentage'
            if(productToDisplay.discounts && productToDisplay.discounts.length > 0){
                productToDisplay.discounts.forEach((discount) => {
                    if(range.min >= discount.min) {
                        discountAmount = discount.discount;
                        discountType = discount.percentage_discount == true ? 'percentage' : 'fixed';
                    }
                })
            }
            discounts.push({'discount_amount': discountAmount, 'discount_type': discountType});
        })
        productToDisplay['discount_amounts'] = discounts;
    })
}

const generateRows = function(productsToDisplay){
    let tableBody = document.querySelector(`${bulkDiscountsSettings.selectors.tableHeaderSelector}`).closest('tbody');

    tableBody.querySelectorAll(`${bulkDiscountsSettings.selectors.tableRowSelector}`).forEach(el => el.remove());    

    productsToDisplay.forEach((productToDisplay, index) => {
        let lowestPrice = 999999999999999999;
        let ContentCellsHtml = `<tr class="bulk-discounts-dropdown__table-row">${bulkDiscountsSettings.htmlElements.tableContentCell.replace('#content#', `Price/${productToDisplay['product_type']}`)}`
    
        productToDisplay.discount_amounts.forEach((discountAmount)=> {
            let price;
            if(discountAmount[`discount_type`] == 'percentage'){
                price = parseInt(((100 - discountAmount[`discount_amount`]) * productToDisplay.price) / 10000);

            } else {
                price = parseInt((productToDisplay.price - (100 * discountAmount[`discount_amount`])) / 100);
            }
            if(price < lowestPrice) {
                lowestPrice = price;
            }
            ContentCellsHtml = ContentCellsHtml + `${bulkDiscountsSettings.htmlElements.tableContentCell.replace('#content#', `$${price}`)}`;
        })

        if(index == 0){
            document.querySelector(`${bulkDiscountsSettings.selectors.ctaFromSelector}`).innerHTML = ` from $${lowestPrice}/${productToDisplay.product_type}`
        }
        
        ContentCellsHtml = ContentCellsHtml + '</tr';
        tableBody.insertAdjacentHTML('beforeEnd', ContentCellsHtml);
    });
}

const tableContent = function(bulkDiscountsData, productHandle, headerRanges){
   let quantity = document.querySelector('#atc-cta .quantity-box input[name="quantity"]').value;
    let variantId = parseInt(document.querySelector(`#product-${document.querySelector(`${bulkDiscountsSettings.selectors.dataSelector}`).getAttribute('data-product-id')}-variant`).getAttribute('value'));
    let productsToDisplay = returnProductsToDisplay(bulkDiscountsData, productHandle, variantId);

    calculateDiscounts(productsToDisplay, headerRanges);
    generateRows(productsToDisplay);
    priceSavings(quantity, productsToDisplay)
}

const highlightColumn = function(highlightIndex){
    let highlightColumns = document.querySelectorAll(`${bulkDiscountsSettings.selectors.highlightCellSelector}`)
    if(highlightColumn.length > 0){
        highlightColumns.forEach((highlightColumn) => {
            highlightColumn.classList.remove(`${bulkDiscountsSettings.selectors.highlightCellSelector.replace(".", "")}`)
        })
    }
    if(highlightIndex >= 0) {
        let highlightHeaderCell = document.querySelectorAll(`${bulkDiscountsSettings.selectors.tableHeaderCellSelector}`)[highlightIndex + 1];
        let tableRows = document.querySelectorAll(`${bulkDiscountsSettings.selectors.tableRowSelector}`);
        if(highlightHeaderCell){highlightHeaderCell.classList.add(`${bulkDiscountsSettings.selectors.highlightCellSelector.replace(".", "")}`)}
        if(tableRows.length > 0){
            tableRows.forEach((tableRow) => {
                highlightContentCell = tableRow.querySelectorAll('td')[highlightIndex + 1];
                if(highlightContentCell){highlightContentCell.classList.add(`${bulkDiscountsSettings.selectors.highlightCellSelector.replace(".", "")}`)};
            })
        }
    }
}

const priceSavings = function(quantity, productsToDisplay){
    let price = 0;
    let originalPrice = 0;
    let variantSelector = document.querySelector('#mobile-sticky-atc input[name="id[]"]');
    let variantId = null;
    if(variantSelector){
        variantId = variantSelector.value;
    }

    // Get the current product handle to target the correct price element
    let productHandle = document.querySelector(`${bulkDiscountsSettings.selectors.dataSelector}`).getAttribute('data-product-handle');

    // Check for discount code "deal" price first - use specific selector to avoid picking up bundle prices
    let dealPriceElement = document.querySelector(`.main-product__title-review-price-container .price[data-product-handle="${productHandle}"] .deal span[data-price="deal"]`);
    let dealPrice = null;
    if(dealPriceElement && dealPriceElement.textContent && dealPriceElement.getAttribute('data-exact-price')){
        dealPrice = parseFloat(dealPriceElement.getAttribute('data-exact-price'));
    } else if (dealPriceElement && dealPriceElement.textContent) {
        // Extract numeric value and convert to cents
        let dealPriceText = dealPriceElement.textContent.replace(/[^0-9.]/g, '');
        if (dealPriceText) {
            dealPrice = parseFloat(dealPriceText) * 100;
        }
    }

    // Fallback to IG price if no deal price
    let igPrice = null;
    if (!dealPrice && variantId && window.igData && window.igData.price && window.igData.price.getPriceByVariantId) {
        igPrice = parseFloat(window.igData?.price.getPriceByVariantId(variantId)+"00");
    }

    let priceElement = document.querySelector(`${bulkDiscountsSettings.selectors.priceElementSelector}`);
    let savingsElement = document.querySelector(`${bulkDiscountsSettings.selectors.savingsElementSelector}`);
    let highlightIndex = -1;

    productsToDisplay.forEach((productToDisplay, index) => {
        let discountAmount = 0;
        let discountType = 'percentage';

        // Apply deal price first, then IG price if available
        if (dealPrice) {
            productToDisplay.price = dealPrice;
        } else if (igPrice) {
            productToDisplay.price = igPrice;
        }

        if(quantity > 10){
            let productHandle = productToDisplay.handle;
            if(productHandle && discountCodeData){
                if(discountCodeData.discount_code_1_product_handles.replaceAll(' ', '').split(",").includes(productHandle) && discountCodeData.discount_code_1_amount != undefined && discountCodeData.discount_code_1_amount > 0){
                    productToDisplay.price = productToDisplay.price * (100 / (100 - discountCodeData.discount_code_1_amount))
                } else if(discountCodeData.discount_code_2_product_handles.replaceAll(' ', '').split(",").includes(productHandle) && discountCodeData.discount_code_2_amount != undefined && discountCodeData.discount_code_2_amount > 0){
                    productToDisplay.price = productToDisplay.price * (100 / (100 - discountCodeData.discount_code_2_amount))
                }
            }
        }

        originalPrice = originalPrice + (parseInt(quantity) * productToDisplay.price);

        if(productToDisplay.discounts && productToDisplay.discounts.length > 0){
            productToDisplay.discounts.forEach((discount, discountIndex) => {
                if(quantity >= discount.min){
                    discountAmount = discount.discount;
                    discountType = discount.percentage_discount == true ? 'percentage' : 'fixed';
                    if(index == 0){
                        highlightIndex = discountIndex;
                    }
                }
            });
        }

        if(discountType == 'percentage') {
            price = price + (((100 - discountAmount) * (parseInt(quantity) * productToDisplay.price))/100);
        } else {
            price = price + (((parseInt(quantity) * (productToDisplay.price - (100 * discountAmount)))));
        }
    });

    highlightColumn(highlightIndex);

    priceElement.innerHTML = `$${(price / 100).toFixed(0)}`;

    if(price < originalPrice){
        savingsElement.innerHTML = `save $${((originalPrice - price) / 100).toFixed(0)}`;
        savingsElement.style.paddingLeft = '0.7em';
    } else {
        savingsElement.innerHTML = '';
        savingsElement.style.paddingLeft = '0';
    }
}

const initButton = function(bulkDiscountsData, productHandle, headerRanges){
    const ctaButton = document.querySelector(bulkDiscountsSettings.selectors.ctaButtonContainerSelector).parentElement;
    ctaButton.addEventListener('click', (e) => toggleDropdown(e, null, bulkDiscountsData, productHandle, headerRanges));
}

const initQuantityObserver = function(bulkDiscountsData, productHandle, headerRanges){
    let quantityInput = document.querySelector(`${bulkDiscountsSettings.selectors.quantityInputSelector}`);

    quantityInput.onchange = function () {
        tableContent(bulkDiscountsData, productHandle, headerRanges);

        const experimentId = 'a37a72db-7327-4007-9723-087dd33fd07c';
        const noVdTg = 'a99a8364-3ca8-4a1a-81f3-1d91f4059fb2';
        let igSkipHide = false;
        if (window.igData && window.igData.user){
            const tg = window.igData.user.getTestGroup(experimentId);
            if (tg && tg.id === noVdTg){
                igSkipHide = true;
            }
        }
        if(!igSkipHide && quantityInput.value >= headerRanges[0].min &&  document.querySelector(bulkDiscountsSettings.selectors.containerSelector).getAttribute('data-status') == 'closed' && !document.querySelector(bulkDiscountsSettings.selectors.containerSelector).classList.contains("ig-hidden")){
            toggleDropdown(null, 'onQuantityChange', bulkDiscountsData, productHandle, headerRanges);
            setTimeout(() => {
                scrollToATC();
            }, 250);
        }
        // Disabled auto-closing when quantity goes below threshold - user can manually close the dropdown if desired
        // else if(!igSkipHide && quantityInput.value < headerRanges[0].min &&  document.querySelector(bulkDiscountsSettings.selectors.containerSelector).getAttribute('data-status') == 'open' && !document.querySelector(bulkDiscountsSettings.selectors.containerSelector).classList.contains("ig-hidden")){
        //     toggleDropdown(null, 'onQuantityChange', bulkDiscountsData, productHandle, headerRanges);
        //     setTimeout(() => {
        //         scrollToATC();
        //     }, 250);
        // }
    }
    findAncestor(quantityInput, `${bulkDiscountsSettings.selectors.quantityBoxSelector}`).querySelectorAll('button').forEach((button) => button.onclick = function(){tableContent(bulkDiscountsData, productHandle, headerRanges)});
}

const initProductObserver = function(bulkDiscountsData, productHandle, headerRanges){
    let productID = document.querySelector(`${bulkDiscountsSettings.selectors.dataSelector}`).getAttribute('data-product-id');
    let productVariantInput = document.querySelector(`#product-${productID}-variant`);
    let addonProductsInput = document.querySelector(`${bulkDiscountsSettings.selectors.addonProductsInputSelector}`);
    let mutating = false;
    
    var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type === "attributes" && mutating == false) {
                mutating = true;
                tableContent(bulkDiscountsData, productHandle, headerRanges)
                setTimeout(function() {
                    mutating = false;
                }, 500);
            }
        });
    });

    if(addonProductsInput){
        observer.observe(addonProductsInput, {attributes: true});
    }

    if(productVariantInput){
        observer.observe(productVariantInput, {attributes: true});
    }
}

const processBulkDiscounts = function(bulkDiscountsData) {
    for (const product in bulkDiscountsData) {
        let bulk_discount_table_exist = bulkDiscountsData[product].bulk_discount_table && Object.keys(bulkDiscountsData[product].bulk_discount_table).length > 0;
        if(bulk_discount_table_exist == true){
        bulkDiscountsData[product].bulk_discount_table = bulkDiscountsData[product].bulk_discount_table
            .filter(discount => discount.max >= 11) 
            .map(discount => {
                if (discount.min < 11) {
                    discount.min = 11;
                }
                return discount;
            });
        }
    }
    return bulkDiscountsData;
}

const initBulkDiscountsDropdown = function(){
    var windowWidth = window.innerWidth
    if(document.querySelector(`${bulkDiscountsSettings.selectors.dataSelector}`)){
        let bulkDiscountsData = JSON.parse(document.querySelector(`${bulkDiscountsSettings.selectors.dataSelector}`).innerHTML);
        let productHandle = document.querySelector(`${bulkDiscountsSettings.selectors.dataSelector}`).getAttribute('data-product-handle');
        let currentProductData = bulkDiscountsData[`${productHandle}`];

        if(bulkDiscountsData && productHandle && currentProductData && currentProductData['bulk_discount_table'] && currentProductData['bulk_discount_table'].length > 0){
            let discountCodeProduct = currentProductData['product_discount_code'] == 'true' ? true : false;
            if(discountCodeProduct){
                bulkDiscountsData = processBulkDiscounts(bulkDiscountsData);
                currentProductData = bulkDiscountsData[`${productHandle}`];
            }
        }
        
        if(bulkDiscountsData && productHandle){
            if(currentProductData['bulk_discount_table'] && currentProductData['bulk_discount_table'].length > 0){
                let headerRanges = [];
                tableHeader(currentProductData, headerRanges);
                // Initialize table content on page load to populate "from" price
                tableContent(bulkDiscountsData, productHandle, headerRanges);
                initButton(bulkDiscountsData, productHandle, headerRanges);
                initQuantityObserver(bulkDiscountsData, productHandle, headerRanges);
                initProductObserver(bulkDiscountsData, productHandle, headerRanges);
                window.addEventListener('resize', function(event) {

                    if (window.innerWidth != windowWidth) {
                        windowWidth = window.innerWidth
                    }
                }, true
                );
            }
        }
    }
}

window.addEventListener('load', function(){
    initBulkDiscountsDropdown();
});